import React from 'react';
import i2 from "../img/Aman3.jpg";
import { Link } from 'react-router-dom';
import { motion } from "framer-motion";

export default function AboutMe() {
  return (
    <div>
      <div
        id='homeabout'
        className="max-w-screen-lg mx-auto grid grid-rows md:grid-flow-col 
         items-center justify-center h-full md:flex-row"
      >
        <div className="col-span-1  pr-10 md:col-span-1 pl-10">
          <img
            src={i2}
            alt="IMG2"
            className="mx-auto w-2/3 md:w-full"
          />
        </div>

        <motion.div
          initial={{ opacity: 0, y: 50 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.2 }}
          className="flex flex-col justify-center h-full  md: px-5 mx-5"
        >
          <h2 className="text-2xl md:text-4xl font-bold">
            About me
          </h2>
          <p className="py-4 max-w-md">
            Hi! I am Aman Shaikh, a web designer/developer focused on crafting
            great web experiences. Designing and Coding have been my passion
            since the days I started working with computers but I found myself
            into web design/development since 2021. I enjoy creating beautifully
            designed, intuitive and functional websites.
          </p>

          <div>
            <Link to="https://drive.google.com/file/d/1C6ed7Om5WUr6s5Jvb_8UMDVlw2Adc7Jz/view?usp=drive_link">
              <button
                type="button"
                className="text-white bg-gradient-to-r from-cyan-400 via-cyan-500 to-cyan-600 hover:bg-gradient-to-br focus:ring-4 focus:outline-none focus:ring-cyan-300 dark:focus:ring-cyan-800 font-medium rounded-lg text-sm px-5 py-2.5 text-center mr-2 mb-2"
              >
                Download CV
              </button>
            </Link>
          </div>
        </motion.div>
      </div>
    </div>
  );
}
